// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_HuG","question":"styles_question__1e5MI","description":"styles_description__1ugGz"};